import React from 'react'
import { FormattedMessage } from 'react-intl'
import Link from 'redux-first-router-link'
import Avatar from 'components/Avatar'
import PersonName from 'components/PersonName'
import EntityName from 'components/EntityName'
import RelativeTime from 'components/RelativeTime'
import styles from './Activity.css'

const PublishedMessage = ({ group }) => {
  if (group) {
    return (
      <span className={styles.published}>
        <FormattedMessage id={`activity.publish`} />
        <Link
          to={{
            type: 'groups/group/activity',
            payload: {
              group: group._id
            }
          }}
        >
          {group.name}
        </Link>
      </span>
    )
  } else {
    return <FormattedMessage id={`activity.publish_to_all`} />
  }
}

const MemberOrProfileLink = ({ you, them, children }) => {
  if (you && them && you._id === them._id) {
    return (
      <Link
        to={{
          type: 'profile/public/posts',
          payload: {
            // modal: true
          }
        }}
      >
        {children}
      </Link>
    )
  } else {
    return (
      <Link
        to={{
          type: 'home/member/posts',
          payload: {
            username: them.username || "unknown"
          }
        }}
      >
        {children}
      </Link>
    )
  }
}

const ActivityAction = ({
  you,
  actor = {},
  object,
  target,
  group,
  verb,
  time,
  notificationMode
}) => {
  return (
    <div className={styles.action}>
      {actor.avatar ? (
        <MemberOrProfileLink you={you} them={actor}>
          <Avatar avatar={actor.avatar} />
        </MemberOrProfileLink>
      ) : (
        undefined
      )}
      <div className={styles.summary}>
        <div className={styles.description}>
          <MemberOrProfileLink you={you} them={actor}>
            <PersonName person={actor} you={you} />
          </MemberOrProfileLink>
          <span className={styles.verb}>
            {verb === 'publish' ? (
              notificationMode ? (
                <FormattedMessage id={`activity.mentioned_you`} />
              ) : (
                <PublishedMessage group={group} />
              )
            ) : (
              <FormattedMessage id={`activity.${verb}`} values={object} />
            )}
          </span>
          {verb === 'follow' ? (
            <PersonName person={object} you={you} />
          ) : target ? (
            <EntityName name={target.name || '_missing'} />
          ) : null}
        </div>
        <RelativeTime className={styles.meta} value={time} />
      </div>
    </div>
  )
}

export default ActivityAction
